import React from "react";
import { Link } from "react-router-dom";

export default function ThankYouPage() {
  const isMobile = window.innerWidth <= 768;

  return (
    <div
      style={{
        width: "100hw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#2a4071",
      }}
    >
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 10,
          height: "70%",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            height: "60%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            style={{
              height: isMobile ? "50px" : "80px",
              width: "auto",
              objectFit: "contain",
            }}
            src={"images/simpleman-white.png"}
            alt="Logo Simpleman"
          />
          <h1 style={{ color: "white", fontSize: 50 }}>
            Grazie per aver richiesto la demo!
          </h1>
        </div>
        <Link
          to="https://simpleman.it"
          style={{
            backgroundColor: "white",
            padding: 10,
            borderRadius: 5,
            textDecoration: "none",
            width: "fit-content",
          }}
        >
          {"Torna alla Home"}
        </Link>
      </div>
    </div>
  );
}
